import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Workshop } from '../../../../../models/workshop';
import { WorkshopsComponent } from '../../workshops.component';
import { WorkshopHours } from '../../../../../models/workshopHours';
import { APIAttentionSchedule } from 'src/services/api-services/api-service-attention-schedule';
import { ServiceAttentionSchedule } from 'src/services/api-services/api-interfaces/api-interface-attention-schedule';
import { finalize, Subject, takeUntil, tap } from 'rxjs';
import { Validators } from '@angular/forms';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/services/helperService';




@Component({
    selector: 'app-configure-hours',
    templateUrl: './configure-hours.dialog.html',
    styleUrls: ['./configure-hours.dialog.sass'],
    standalone: false
})
export class ConfigureHoursDialog {
  constructor(
    public dialogRef: MatDialogRef<WorkshopsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public workshop: Workshop,
    public attetionSchedulerservice: APIAttentionSchedule,
    private translate: TranslateService,
    public helperService: HelperService
  ) {}

  isCopyHoursOfMonday: boolean = false;
  Attenciondata: any = [];
  dropdownData: boolean = false;
  editWorkshopLoading: boolean = true;
  public StartHour: any = '10:00 A.M.';
  public hourFinal: any = '6:00 P.M.';
  public StartDate: any = '';
  TypeFuncionality: any;
  days: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  Mon: any = [{ isActive: undefined, hourInitial: '', hourFinal: '' }];
  v1: number = 24;
  v2: number = this.v1;

  dataInt: ServiceAttentionSchedule = {
    workshopId: '',
    attentionScheduleId: 0,
    dayOfWeek: '',
    hourInitial: '',
    hourFinal: '',
    isActive: false,
    start: '',
    end: '',
    dayNumber: 0,
  };

  daysOfWeeks: any[] = [
    { day: 'Monday', daySet: 'Mon', arrayHours: [], dayNumber: 1, validateHours:false },
    { day: 'Tuesday', daySet: 'Tue', arrayHours: [], dayNumber: 2, validateHours:false },
    { day: 'Wednesday', daySet: 'Wed', arrayHours: [], dayNumber: 3, validateHours:false },
    { day: 'Thursday', daySet: 'Thu', arrayHours: [], dayNumber: 4, validateHours:false },
    { day: 'Friday', daySet: 'Fri', arrayHours: [], dayNumber: 5, validateHours:false },
    { day: 'Saturday', daySet: 'Sat', arrayHours: [], dayNumber: 6, validateHours:false },
    { day: 'Sunday', daySet: 'Sun', arrayHours: [], dayNumber: 0, validateHours:false },
  ];

  timehours: string[] = [];


  ngOnInit(): void {
    this.getAttentionScheduleService();
    this.intervalHours();
  }
  // bring the hours of operation
  getAttentionScheduleService() {
    let id = sessionStorage.getItem('attetionSchedulerservice') || '';
    this.attetionSchedulerservice
      ?.getDealerBlockedSchedule(this.workshop.workshopId)
      .pipe(
        tap((response) => {
          if (!response.message) {
           
            this.Attenciondata = response;

            for (let i = 0; i < this.days.length; i++) {
              this.Mon[i] = this.Attenciondata.filter(
                (data) => data.dayOfWeek === this.days[i]
              );
            }
           
          } else {
            for (let i = 0; i < 7; i++) {
              this.Mon[i] = [{ isActive: undefined }];
            }

            this.DataInt();
          }
        }),
        takeUntil(this.destroy$),
        finalize(() => this.DataInt())
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe(); //  You can replace this with this.destroy$.complete() as well
  }

  intervalHours(){
    const openTime: Date = new Date(0,0,0,5,0,0);
    const closeTime: Date = new Date (0,0,0,19,45,0);
    const stepTime: number = 15 * 60 * 1000;

    for(let hour = openTime.getTime(); hour <= closeTime.getTime(); hour += stepTime){

      const timeString: string = new Date (hour).toLocaleTimeString("es-CO", { hour: 'numeric', minute: '2-digit', hour12: true})
      this.timehours.push(timeString.toUpperCase());
    }
  }


  ValidationOfCorrectHoursWorkshop(index){

    let hour = moment(this.daysOfWeeks[index].startTime, 'h:mm A').format('HH:mm:ss');
    let split = hour.split(':');
    let hour_inicial_validacion = Number(split[0] + split[1]);
    hour = moment(this.daysOfWeeks[index].endTime, 'h:mm A').format('HH:mm:ss')
    split = hour.split(':');
    let hour_final_validacion = Number(split[0] + split[1]);
    this.daysOfWeeks[index].validateHours=false
    if (hour_inicial_validacion > hour_final_validacion) {
      //if any filter is filled the button will be enabled
      this.daysOfWeeks[index ].validateHours=true
    }

  }

  issaveDisabled(): boolean {
    // function to enable clear button conditionally
    let isDisabled = true;
    if (
      this.daysOfWeeks.filter((daysOfWeeks) => daysOfWeeks.validateHours === true).length === 0
    ) {
      //if any filter is filled the button will be enabled
      isDisabled = false;
    }
    return isDisabled;
  }

  //trasformation data
  DataInt() {
    if (this.Mon[0].map((data) => data.isActive)[0] === undefined) {
      this.TypeFuncionality = 'New';
    } else {
      this.TypeFuncionality = 'Old';
    }

    this.dropdownData = true;

    for (let i = 0; i < this.daysOfWeeks.length; i++) {
      this.daysOfWeeks[i].isActive = this.Mon[i].map(
        (data) => data.isActive
      )[0];
      this.daysOfWeeks[i].arrayHours = [...this.timehours];

      this.daysOfWeeks[i].startTime = this.Mon[i]
        .map((data) => data.hourInitial)
        .toString();

      this.daysOfWeeks[i].endTime = this.Mon[i]
        .map((data) => data.hourFinal)
        .toString();

     
      let hour = this.daysOfWeeks[i].startTime.split(':');
      this.daysOfWeeks[i].startTime = this.militaryTimeToNormalTime(
        Number(hour[0]),
        hour[1]
      );
      hour = this.daysOfWeeks[i].endTime.split(':');
      this.daysOfWeeks[i].endTime = this.militaryTimeToNormalTime(
        Number(hour[0]),
        hour[1]
      );
      this.ValidationOfCorrectHoursWorkshop(i)
    }
   
  }

  // change to standard time
 militaryTimeToNormalTime(Hor: number, Hor2: string) {
  let hora: any = Hor;
  let string = '';

  if (Hor > 12) {
    hora = hora - 12;
    string = hora + ':' + Hor2 + ' P. M.';
  } else if (Hor === 0) {
    string = '';
  } else if (Hor === 12) {
    string = hora + ':' + Hor2 + ' P. M.';
  } else {
    string = Hor + ':' + Hor2 + ' A. M.';
  }

  return string.trim();
}

  convertTime12To24(time) {
    let hours = Number(time.match(/^(\d+)/)[1]);
    let minutes = Number(time.match(/:(\d+)/)[1]);
    let AMPM = time.match(/\s(.*)$/)[1].trim();
  
    if (AMPM === 'P. M.' && hours < 12) {
      hours += 12;
    }
  
    if (AMPM === 'A. M.' && hours === 12) {
      hours = 0;
    }
  
    return (
      hours.toString().padStart(2, '0') +
      ':' +
      minutes.toString().padStart(2, '0')
    );
  }

  onCancel(): void {
    this.dialogRef.close();
  }
  onSave() {
    if (this.TypeFuncionality === 'Old') {
      for (let i = 0; i < 7; i++) {
        this.dataInt.workshopId = this.Mon[i].map((data) => data.workshopId)[0];
        this.dataInt.attentionScheduleId = this.Mon[i].map(
          (data) => data.attentionScheduleId
        )[0];
        this.dataInt.dayOfWeek = this.daysOfWeeks[i].daySet;
        this.dataInt.hourInitial = this.daysOfWeeks[i].startTime;
        this.dataInt.hourFinal = this.daysOfWeeks[i].endTime;
        this.dataInt.isActive = this.daysOfWeeks[i].isActive;
        this.dataInt.dayNumber = this.daysOfWeeks[i].dayNumber;
        if (this.isCopyHoursOfMonday === true) {
          this.dataInt.hourInitial =
            this.convertTime12To24(this.daysOfWeeks[0].startTime) + ':00';
          this.dataInt.hourFinal =
            this.convertTime12To24(this.daysOfWeeks[0].endTime) + ':00';
        } else {
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== ''
          ) {
            this.dataInt.hourInitial =
              this.convertTime12To24(this.daysOfWeeks[i].startTime) + ':00';
            this.dataInt.hourFinal =
              this.convertTime12To24(this.daysOfWeeks[i].endTime) + ':00';
          }
        }
        if (this.Mon[i].map((data) => data.workshopId)[0] === undefined) {
          this.dataInt.workshopId = this.workshop.workshopId;
          this.dataInt.attentionScheduleId = 0;
          this.dataInt.dayOfWeek = this.daysOfWeeks[i].daySet;
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== '' &&
            this.dataInt.hourInitial !== undefined &&
            this.dataInt.hourFinal !== undefined
          ) {
            this.attetionSchedulerservice?.post(this.dataInt).subscribe();
          }
        } else {
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== '' &&
            this.dataInt.hourInitial !== undefined &&
            this.dataInt.hourFinal !== undefined
          ) {
            this.attetionSchedulerservice?.put(this.dataInt).subscribe();
          }
        }
      }
    } else {
      for (let i = 0; i < 7; i++) {
        this.dataInt.workshopId = this.workshop.workshopId;
        this.dataInt.attentionScheduleId = 0;
        this.dataInt.dayOfWeek = this.daysOfWeeks[i].daySet;
        this.dataInt.hourInitial = this.daysOfWeeks[i].startTime;
        this.dataInt.hourFinal = this.daysOfWeeks[i].endTime;
        this.dataInt.isActive = this.daysOfWeeks[i].isActive;
        this.dataInt.dayNumber = this.daysOfWeeks[i].dayNumber;
        if (this.isCopyHoursOfMonday === true) {
          this.dataInt.hourInitial =
            this.convertTime12To24(this.daysOfWeeks[0].startTime) + ':00';
          this.dataInt.hourFinal =
            this.convertTime12To24(this.daysOfWeeks[0].endTime) + ':00';
        } else {
          if (
            this.dataInt.hourInitial !== '' &&
            this.dataInt.hourFinal !== ''
          ) {
            this.dataInt.hourInitial =
              this.convertTime12To24(this.daysOfWeeks[i].startTime) + ':00';
            this.dataInt.hourFinal =
              this.convertTime12To24(this.daysOfWeeks[i].endTime) + ':00';
          }
        }
        if (
          this.dataInt.hourInitial !== '' &&
          this.dataInt.hourFinal !== '' &&
          this.dataInt.hourInitial !== undefined &&
          this.dataInt.hourFinal !== undefined
        ) {
          this.attetionSchedulerservice?.post(this.dataInt).subscribe();
        }
      }
    }
    const translateText = this.translate.instant(
      'ToastWorkshopConfigure',
      {
        fullName:this.workshop.workshopName
      }
    )
    this.helperService.showAlert =true
    this.helperService.typeAlert ="success"
    this.helperService.messageAlert =translateText

    setTimeout(() => {
      this.helperService.showAlert =false

      }, 7000)
    this.dialogRef.close('NewData');
  }
}
